import { doc, getDoc, updateDoc } from "firebase/firestore";

import { NOTIFICATION_ID } from "../constants/Notification";
import getIsoStringFromTimestamp from "../helper/getIsoStringFromTimestamp";
import { Notification } from "../interfaces/Notification";
import { db } from "./firebase";

const updateBenifitofVerificationPopup = async (userId: string) => {
  const userRef = doc(db, `users/${userId}`);
  await updateDoc(userRef, {
    benifitOfVerificationPopup: true,
  });
};
const updateProfileCompletenessPopup = async (userId: string) => {
  const userRef = doc(db, `users/${userId}`);
  await updateDoc(userRef, {
    profileCompletionPopup: true,
  });
};
const updateFirstTimeLoginPopup = async (userId: string) => {
  const userRef = doc(db, `users/${userId}`);
  await updateDoc(userRef, {
    firstTimeLoginPopup: true,
  });
};
const updateFirstTimeGigPopup = async (userId: string) => {
  const userRef = doc(db, `users/${userId}`);
  await updateDoc(userRef, {
    displayFirstGigPopup: true,
  });
};

const getNotificationDetails = async (notificationId: NOTIFICATION_ID) => {
  const notificationRef = doc(db, `notification/${notificationId}`);
  const notificationDoc = await getDoc(notificationRef);
  if (notificationDoc.exists()) {
    const notification = notificationDoc.data();
    return notification;
  }
  return;
};

export {
  updateProfileCompletenessPopup,
  updateFirstTimeLoginPopup,
  updateFirstTimeGigPopup,
  updateBenifitofVerificationPopup,
  getNotificationDetails,
};
